import AppleIcon from '@mui/icons-material/Apple';
import { Button } from '@mui/material';
import AppleLogin from 'react-apple-login';
import IAppleUser from '../../components/entities/apple-user.dto';
import { LOGON_METHOD } from '../../components/entities/sys-constants';
import { default as ILogin, default as IUser } from '../../components/entities/user';
import { addLog } from '../../redux/slices/log';
import { clearUser, setUser } from '../../redux/slices/user';
import { store } from '../../redux/store';
import { registerUser, setCredentials } from './auth.service';

// import AppleUserService from "../../db/services/apple-user.service";
// import UserInfoService from "../../db/services/user.service";
// import IAppleUser from "../../entities/apple-user.dto";

// import { LOGON_METHOD } from "../../entities/sys-constants";
// import IUser from "../../entities/user";
// import store from "../../stores/store";

// import AuthService from "./auth.service";

export default function SignInWithApple(onSuccess: any) {
    async function getUserInfo(u: any) {
        const user: IAppleUser = {
            authorizationCode: u.authorizationCode ?? '',
            email: u.email ?? undefined,
            familyName: u.fullName?.familyName ?? '',
            givenName: u.fullName?.givenName ?? '',
            middleName: u.fullName?.middleName ?? '',
            namePrefix: u.fullName?.namePrefix ?? '',
            nameSuffix: u.fullName?.nameSuffix ?? '',
            nickname: u.fullName?.nickname ?? '',
            identityToken: u.identityToken ?? '',
            realUserStatus: u.realUserStatus.toString(),
            state: u.state ?? '',
            user: u.user ?? ''
        };

        const loginUser: ILogin = {
            userId: u.user ? u.user : '',
            email: u.email ? u.email : 'uzoffer@apple.com',
            userName: u.fullName?.givenName ? u.fullName?.givenName : '',
            photoUrl: '',
            logonMethod: LOGON_METHOD.APPLE,
            password: 'P@$$w0rd#1',
            id: '0',
            accountType: 1
        };

        await registerUser(loginUser)
            .then((res: any) => {
                const userModel: IUser = {
                    userId: res['payload']['userId'],
                    email: res['payload']['email'],
                    userName: res['payload']['userName'],
                    firstName: res['payload']['firstName'],
                    lastName: res['payload']['lastName'],
                    password: res['payload']['password'],
                    userRole: res['payload']['userRole'],
                    phoneNumber: res['payload']['phoneNumber'],
                    photoUrl: res['payload']['photoUrl'],
                    logonMethod: res['payload']['logonMethod'],
                    accountType: 1
                };

                if (res.status === 'Failed' || res.status === 400) {
                    // Apple login failed
                } else {
                    const authResponse = res.payload;
                    setCredentials({
                        accessToken: authResponse.accessToken,
                        refreshToken: authResponse.refreshToken
                    });

                    const appUser: IUser = {
                        accountType: 0
                    };

                    appUser.email = loginUser.email;
                    appUser.userName = authResponse.userName;
                    appUser.firstName = authResponse.firstName;
                    appUser.lastName = authResponse.lastName;
                    appUser.id = authResponse.id;
                    appUser.logonMethod = LOGON_METHOD.APPLE;
                    appUser.accessToken = authResponse.accessToken;
                    appUser.refreshToken = authResponse.refreshToken;
                    appUser.userId = userModel.userId;

                    appUser.gender = res.payload.gender;
                    appUser.address = res.payload.address;
                    appUser.photoUrl = res.payload.photoUrl;
                    appUser.phoneNumber = res.payload.phoneNumber;
                    appUser.telegramNumber = res.payload.telegramNumber;
                    appUser.whatsappNumber = res.payload.whatsappNumber;

                    appUser.companyAddress = res.payload.companyAddress;
                    appUser.companyFacebook = res.payload.companyFacebook;
                    appUser.companyLinkedin = res.payload.companyLinkedin;
                    appUser.companyMobile = res.payload.companyMobile;
                    appUser.companyName = res.payload.companyName;
                    appUser.companyWebSite = res.payload.companyWebSite;
                    appUser.companyYoutube = res.payload.companyYoutube;
                    appUser.accountType = res.payload.accountType;
                    appUser.companyInstagram = res.payload.companyInstagram;
                    appUser.backgroundImage = res.payload.backgroundImage;

                    //    sessionStorage.setItem('UserInfo', JSON.stringify(appUser));
                    store.dispatch(setUser(appUser));
                    store.dispatch(addLog('User logged in with Apple'));
                    window.location.href = '/';
                }
            })
            .catch(async () => {});
    }

    const responseApple = async (response: any) => {
        await getUserInfo(response);
        onSuccess();
    };

    return (
        <AppleLogin
            clientId="com.startup.UzOffer"
            scope="email name"
            redirectURI="https://uzoffer.com"
            callback={responseApple}
            //usePopup={true}
            render={(renderProps) => (
                <Button startIcon={<AppleIcon sx={{ color: 'text.primary' }} />} variant="outlined" fullWidth sx={{ color: 'text.primary' }} onClick={renderProps.onClick}>
                    Apple
                </Button>
            )}
        />
    );
}

export async function appleSignOut() {
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('UserInfo');
    store.dispatch(clearUser());
}
